import { http } from '../request'
import type { OperatorInfo } from './shared'

type PublishValidationResult = {
  canPublish: boolean
  checks: Array<{ name: string; passed: boolean; message: string }>
  summary: string
  blockingIssues: Array<{ code: string; message: string; suggestion: string }>
}

type PublishResponse = {
  id: number
  name: string
  status: string
  publishedAt: string
  publishedBy: OperatorInfo
  publishedSnapshotId: number
}

type UnpublishResponse = {
  id: number
  status: string
  previousStatus: string
  unpublishedAt: string
}

export const publishApi = {
  async validateForPublish(taskId: number, snapshotId?: number): Promise<PublishValidationResult> {
    const url = snapshotId
      ? `/schedule/tasks/${taskId}/publish/validate?snapshotId=${snapshotId}`
      : `/schedule/tasks/${taskId}/publish/validate`
    const response = await http.post<PublishValidationResult>(url)
    return response.data
  },

  async publishTask(taskId: number, snapshotId: number): Promise<PublishResponse> {
    const response = await http.post<PublishResponse>(
      `/schedule/tasks/${taskId}/publish`,
      { snapshotId }
    )
    return response.data
  },

  async unpublishTask(taskId: number): Promise<UnpublishResponse> {
    const response = await http.post<UnpublishResponse>(
      `/schedule/tasks/${taskId}/unpublish`
    )
    return response.data
  }
}
